var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWatchlistAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 36"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    opacity: 0.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 16.6h-5.7V11c0-.6-.4-1-1-1s-1 .4-1 1v5.6H11c-.6 0-1 .4-1 1s.4 1 1 1h6.3V25c0 .6.4 1 1 1s1-.4 1-1v-6.4H25c.6 0 1-.4 1-1s-.4-1-1-1z",
    fill: "#304256"
  })));
}

export default SvgWatchlistAdd;